// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RiJRq","type":"styles_type__jRKEl","choices":"styles_choices__4n__Q"};